<template>
  <ul class="space-y-4">
    <li v-for="({ label, text, thumbnail }, key) in data" :key class="flex items-center gap-4">
      <div v-if="showThumbnails" class="w-12 shrink-0">
        <base-picture
          v-if="thumbnail"
          :alt="label"
          class="shrink-0"
          fit="contain"
          height="48"
          :src="thumbnail"
          width="48"
        />
      </div>
      <div class="grow space-y-1">
        <p v-if="label" class="subtitle-4">
          <base-interpolator :content="formatBarcodeText(label)">
            <template #product-link="{ args: [pid] }">
              <vf-link
                data-product-barcode-link
                :to="getBarcodeLink()"
              >
                {{ pid }}
              </vf-link>
            </template>
          </base-interpolator>
        </p>
        <div v-if="text" class="ws-pre-wrap" :class="showThumbnails ? 'body-4' : 'body-3'">
          <base-interpolator :content="formatBarcodeText(text)">
            <template #product-link="{ args: [pid] }">
              <vf-link
                data-product-barcode-link
                :to="getBarcodeLink()"
              >
                {{ pid }}
              </vf-link>
            </template>
          </base-interpolator>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { ProductDetailContent } from '#types/product'

const props = defineProps<{
  data: ProductDetailContent[]
  title?: string
}>()

const { productId } = usePdp()
const { formatBarcodeText, getBarcodeLink } = useBarcode(productId.value)
const showThumbnails = props.data?.some(({ thumbnail }) => !!thumbnail)
</script>
